import PageHeader from "@/components/PageHeader";
import Pricing from "@/components/pricing/Pricing";
import pricingPlans from "@/components/pricing/pricingPlans.json";
import { useAccessControl } from "@/features/access-control";
import { OrganizationContext } from "@/features/organizations/components/OrganizationLayout";
import { useAppSelector } from "@/hooks";
import { Button, Container, Grid2 as Grid, Stack, Typography } from "@mui/material";
import { useOutletContext } from "react-router-dom";

const OrganizationPricing = () => {
  const { hasAccess } = useAccessControl();
  const { currentOrganization } = useOutletContext<OrganizationContext>();
  const container = useAppSelector((state) => state.ui?.container);

  return (
    <Stack spacing={3}>
      <PageHeader
        title="Suscripción"
        action={
          hasAccess("update.pricing") ? (
            <Button size="large" color="success" type="submit" fullWidth={false} onClick={() => alert("Guardar")}>
              Guardar
            </Button>
          ) : undefined
        }
      />
      <Stack>
        <Container
          maxWidth={container === 'fixed' ? 'lg' : false}
          sx={{
            height: '100%',
          }}
        >
          <Grid container direction={"row"} spacing={6} p={2}>
            <Grid>
              <Stack spacing={2} alignItems={"center"} pt={"64px"} pb={"48px"}>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: "36px",
                    fontWeight: "400",
                    fontStyle: "normal",
                    lineHeight: "150%",
                    letterSpacing: "0.15px",
                  }}
                >
                  Tecnología para restaurantes modernos,
                  <br />
                  <strong>Recupera tu tiempo y el control</strong>
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    textAlign: "center",
                    fontSize: "24px",
                    fontStyle: "normal",
                    fontWeight: "400",
                    lineHeight: "150%",
                    letterSpacing: "0.15px",
                  }}
                >
                  Toma el control de tus datos para crecer con inteligencia. Comienza a automatizar tus pedidos gratis hoy y mejora tu plan solo cuando estés listo.
                </Typography>
              </Stack>
            </Grid>
            <Grid size={{ xs: 12, lg: 12 }}>
              <Pricing
                plans={pricingPlans?.plans?.map((plan) => ({
                  ...plan,
                  isActive: plan?.id === currentOrganization?.plan,
                  recommended: plan.id === "grow",
                }))}
                onSelect={(planId) => {
                  console.log("Selected plan:", planId);
                }}
              />
            </Grid>
          </Grid>
        </Container>
      </Stack>
    </Stack>
  );
};

export default OrganizationPricing;
